function enumToFilter(enumObject, t, prefixTranslation) {
  var enumMapped = Object.keys(enumObject).map(key => {
    return {
      value: enumObject[key].toString(),
      name: t(`${prefixTranslation}.${key}`)
    };
  });

  return [{ value: -1, name: t('common:selectFirstOptionComboFilter') }, ...enumMapped];
}

function enumToCombo(enumObject, t, prefixTranslation, canBeEmpty) {
  var enumMapped = Object.keys(enumObject).map(key => {
    return {
      value: enumObject[key].toString(),
      name: t(`${prefixTranslation}.${key}`)
    };
  });

  return canBeEmpty ? [{ value: undefined, name: t('common:options.choose') }, ...enumMapped] : enumMapped;
}

function getTranslation(enumValue, enumObject, t, prefixTranslation) {
  const e = Object.entries(enumObject).filter((key, value) => value === enumValue);
  if (e.length > 0) return t(`${prefixTranslation}.${e[0][0]}`);

  return '';
}

export const enumHelper = {
  enumToFilter,
  enumToCombo,
  getTranslation
};
